import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { useAuth } from "@/context/AuthContext";
import { api, shortHash, shortAddr } from "@/lib/api";
import { ScrollText, ArrowLeft } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString();

export default function AdminLogs() {
  const { user, checked } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => { if (checked && !user) nav("/admin/login"); }, [checked, user, nav]);
  useEffect(() => {
    if (user) api.get("/admin/logs").then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, [user]);

  if (!checked || !user) return <Layout><p>Loading…</p></Layout>;

  return (
    <Layout>
      <div className="flex items-center gap-3 mb-4">
        <div className="ks-icon-square"><ScrollText size={18}/></div>
        <div className="flex-1">
          <h1 className="text-xl font-semibold" data-testid="admin-logs-title">Admin Action Log</h1>
          <p className="text-xs text-[var(--ks-text-soft)]">{total} entries · newest first</p>
        </div>
        <Link to="/admin" className="ks-link text-sm flex items-center gap-1" data-testid="back-to-admin"><ArrowLeft size={14}/>Back to Admin</Link>
      </div>
      <div className="ks-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="ks-table" data-testid="admin-logs-table">
            <thead><tr><th>At (UTC)</th><th>Admin</th><th>Action</th><th>Target</th><th className="text-right">Details</th></tr></thead>
            <tbody>
              {items.map((l, i) => (
                <tr key={i} data-testid={`log-row-${i}`}>
                  <td className="mono text-xs">{fmt(l.at)}</td>
                  <td>{l.admin}</td>
                  <td><span className="ks-badge">{l.action}</span></td>
                  <td className="mono text-xs">
                    {l.target?.startsWith("0x") && l.target.length === 42
                      ? <Link to={`/address/${l.target}`} className="ks-link">{shortAddr(l.target)}</Link>
                      : <Link to={`/tx/${l.target}`} className="ks-link">{shortHash(l.target)}</Link>}
                  </td>
                  <td className="text-right text-xs">
                    {l.action === "mint"
                      ? <span>+{l.amount} {l.asset}</span>
                      : <span>→ {l.new_value}</span>}
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={5} className="text-center py-8 text-[var(--ks-text-soft)]">No admin actions recorded yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
